import { all, fork } from 'redux-saga/effects';
import list from './list';
import send from './send';

export default function* message() {
  yield all([fork(list), fork(send)]);
}
